var exports = {
  "M": "x61f99309--79c2f6--menu",
  "A": "x61f99309--79c2f6--item",
};

module.exports = exports;
